import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { sessionGetItemStr, sessionGetItemObj } from '../../../utils/sessionHelpers'
import { getPeriodicManagement } from '../../../redux/actions/periodicManagement'
import PeriodicManagementWidget from '../../../widgets/projectBasedItemsWidget/PeriodicManagementWidget'

export default function PeriodicManagement() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const projectCode = sessionGetItemStr('projectCode')
  const param = sessionGetItemObj('param')
  const { periodNo, periodNumber, periodOfLength } = sessionGetItemObj('periodInfo')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getPeriodicManagement(projectCode, periodNumber)

      setSchema(_schema.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isIncomeAndExpense>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isIncomeAndExpense>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isIncomeAndExpense>
      <ContentHeader
        header={schema?.header || 'จัดการงานงวดโครงการ'}
        subHeader={''}
        isNotCallApi
        isShowGoButton
      />

      {/* 
      periodNo งวดปัจจุบัน (ตัวเลข)
      periodNoText งวดปัจจุบัน (ข้อความ)
      periodOfLength จำนวนงวดทั้งหมด 
      */}
      <PeriodicManagementWidget
        schema={schema}
        periodNoText={periodNo}
        periodNo={periodNumber}
        periodOfLength={periodOfLength}
        projectCode={projectCode}
      />

      <br />
    </SidebarProposal>
  )
}
